











































import { Component, Vue } from 'vue-property-decorator'
import { AxiosResponse } from 'axios'
import UserService from '@/services/UserService'

@Component({ name: 'RequestResetPasswordForm' })
export default class RequestResetPasswordForm extends Vue {
  email: string = ''
  error: string = ''

  async submit () {
    if (!await this.$validator.validateAll()) {
      return
    }

    try {
      const passwordResponse = await UserService.requestResetPassword({ username: this.email, origin: this.$router.resolve('reset-password').href })
      this.$validator.reset()
      this.error = ''
      this.$router.push({ name: 'home', params: { message: this.$tc('password_request.message', 1, { email: this.email }) } })
    } catch (error) {
      const response: AxiosResponse = error.response
      if (response) {
        this.error = response.data.message || response.data.error || 'Reset password error'
      } else {
        throw error
      }
    }
  }
}
